/**
 * @component Index
 * @description
 * Componente de entrada para el módulo de colegios.
 * Renderiza el componente principal `CollegesTable` que contiene la lógica
 * para listar, crear, editar y eliminar colegios registrados en la plataforma.
 *
 * Este componente funciona como wrapper sin props adicionales.
 *
 * @returns {JSX.Element} Render del componente <CollegesTable />
 */

import React from 'react';

import CollegesTable from './table/CollegesTable';

const index = (props) => (
    <CollegesTable />
);

export default index;